import axios from 'axios'
import { UploadFileRequest, UploadFileResponse } from 'types/File'
import { apiClient } from './api'
import { apiv2Client } from './apiv2'

/**
 * ファイルアップロード v1
 * @deprecated uploadFile を使用してください
 */
export const postFileImage = async (data: any) => {
  const file: any = await apiClient.post(`/api/v1/files/upload`, data)
  return file
}

export const postRotateImage = async (
  patientId: string | undefined,
  data: { type: number; file: any },
) => {
  const response: { url: string; fileName: string } = await apiClient.post(
    `/api/v1/files/${patientId}/rotate`,
    data,
  )
  return response
}

export const putGeneratePresignedUrl = async (url: string, file: File) => {
  const response: any = await axios({
    url,
    method: 'PUT',
    data: file,
    headers: {
      'Content-Type': file.type,
    },
  })
  return response
}

export const getFileImage = async (fileName: any) => {
  // NOTE: slash may be included in fileName, so encode twice to prevent it from being decoded by the server
  const url: any = await apiv2Client.get(
    `admin/files/${encodeURIComponent(encodeURIComponent(fileName))}`,
  )
  return url
}

export const putUploadImageBinary = async (
  url: string,
  fileType: string,
  binaryString: string | ArrayBuffer | File,
): Promise<any> =>
  (await axios({
    method: 'PUT',
    url,
    data: binaryString,
    headers: {
      'Content-Type': fileType,
    },
  })) ?? {}

export const uploadFile = async ({
  file,
  type,
}: UploadFileRequest): Promise<UploadFileResponse> => {
  const url = 'admin/files/upload'

  const body = new FormData()
  body.append('file', file)
  body.append('type', type)

  return apiv2Client.request({
    url,
    method: 'POST',
    data: body,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
